<template>
  <v-container fluid v-if="show">
    <v-dialog v-model="show" max-width="600px" v-if="team" :persistent="loading">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;">
            <v-icon style="font-size: 18px;" color="white" class="mr-2">add</v-icon>
            {{ $t(title) }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container class>
            <v-form name="form" ref="formRef" @submit.prevent="onSaveClick">
              <v-row align="center">
                <v-col cols="12" class="px-0 py-1">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerDetail.name') }}</p>
                  <v-text-field
                    class="mb-2 mt-1 slim-input"
                    v-model="team.name"
                    placeholder=" "
                    :rules="requiredRules"
                    dense hide-details outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-0 py-1">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('general.alias') }}</p>
                  <v-text-field
                    class="mb-2 mt-1 slim-input"
                    v-model="team.code"
                    placeholder=" "
                    :rules="requiredRules"
                    dense hide-details outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pl-0 pr-1 py-1">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.countryName') }}</p>
                  <v-autocomplete
                    :loading="!countries"
                    class="mb-2 mt-1 slim-input"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    v-model="team.countryId"
                    placeholder=" "
                    :rules="requiredRules"
                    hide-details
                    dense clearable outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4" class="px-0 py-1">
                  <v-checkbox
                    class="ma-0"
                    v-model="team.youthTeam"
                    hide-details
                    :rules="requiredRules"
                    dense color="secondary"
                  >
                    <template v-slot:label>
                      <span class="body-1 primary--text">{{ $t('general.youth') }}</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="4" class="px-0 py-1">
                  <v-checkbox
                    class="ma-0"
                    v-model="team.male"
                    hide-details
                    :rules="requiredRules"
                    dense color="secondary"
                  >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('general.male') }}</span>
                  </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12" class="pl-0 pr-1 py-1 mt-3">
                  <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('team.parentTeam') }}</p>
                  <v-autocomplete
                    :loading="!teams"
                    class="mb-2 mt-1 slim-input"
                    :items="teams"
                    item-text="name"
                    item-value="id"
                    v-model="team.parentId"
                    placeholder=" "
                    dense hide-details outlined
                    @change="onParenTeamChange($event)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-6 pb-4 d-flex justify-end">
          <v-btn
            :color="$vuetify.theme.dark ? 'white' : 'secondary'"
            rounded outlined class="elevation-0 monospace-font px-4"
            @click="show = false"
            :loading="loading"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            rounded class="elevation-0 monospace-font white--text px-4" color="primary"
            :loading="loading"
            @click="onSaveClick()"
          >{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Dictionary from "../../dictionary";
import * as _ from "lodash";
import DriblabCountryFlag from "./DriblabCountryFlag";
import CountryService from '../../services/country.service';
import TeamService from '../../services//team/team.service';

export default {
  name: "TeamFormModal",
  components: {
    DriblabCountryFlag
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    }
  },
  filters: {},
  props: {
    title: {
      type: String,
      default: "general.team"
    }
  },
  data() {
    return {
      show: false,
      validated: false,
      requiredRules: [
        v =>
          v != null ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"]
      ],
      team: {},
      countries: null,
      teams: null,
      loading: false
    };
  },
  async created() {
    await this.loadCountries();
    await this.loadTeams();
  },
  methods: {
    open(team = {}) {
      this.team = team;
      this.team.youthTeam = false;
      this.team.male = true;
      this.team.bTeam = false;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async loadCountries(){
      let countriesResponse = await CountryService.getAll();
      this.countries = countriesResponse.data;
    },
    async loadTeams(){
      let dataSet = await this.$store.dispatch("getDataSet");
      this.teams = _.orderBy(dataSet.teams,'name','asc');
    },
    async onSaveClick() {
      if (this.$refs.formRef.validate()) {
        try{
          this.loading = true;
          this.team.alias = this.team.code.substring(0,3);
          this.team.teamName = this.team.name;
          let teamResponse = await TeamService.postTeam(this.team);
          this.team.id = teamResponse.data;
          this.team.cC = this.countries.find(c => c.id === this.team.countryId) ? this.countries.find(c => c.id == this.team.countryId).code : "";
          this.$emit("save", this.team);
          this.team = null;
          this.loading = false;
        }catch(e){
          this.loading = false;
        }
      }
    },
    onParenTeamChange(newParentTeamId){
      if(newParentTeamId){
        this.team.youthTeam = true;
      }else{
        this.team.youthTeam = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/TeamFormModal.vue